// extracted by mini-css-extract-plugin
export default {"form":"styles_form__xAKGb","inputs":"styles_inputs__ls8Rt","input":"styles_input__1Cu33","inputArea":"styles_inputArea__2OJnQ","addButton":"styles_addButton__2UygR"};